import { AnimatedSprite, Texture, Rectangle } from 'pixi.js'
import loopFlamePng from "./frames/flames/flames_loop.png";
import raiseFlamePng from "./frames/flames/flames_low.png";
import loopTransitionPng from "./frames/flames/flames_transition.png";
import redFlamePNG from "./frames/flames/flames_low_red.png";

// import shuttleEndPNG from "./Shuttle-Final.png";
import spaceshipNewPNG from "./spaceship_new.png";


export class Shuttle {
  constructor() {
    this.container;
  }

  getShuttleResourses = () => {
    return [
      ["loopFlamePng", loopFlamePng],
      ["raiseFlamePng", raiseFlamePng],
      // ["shuttleEndPNG", shuttleEndPNG],
      ["spaceshipNewPNG", spaceshipNewPNG],
      ["loopTransitionPng", loopTransitionPng],
      ["redFlamePNG", redFlamePNG],
    ];
  };

  initShuttle = () => {

  
  };

  createSprite(textures) {
    let sprite = new AnimatedSprite(textures)
    sprite.anchor.set(0.5, 0.5)
    sprite.loop = false

    return sprite
  }

  getTextures(jsonframes, baseTxt) {
    let frames = Object.values(jsonframes)
    let textures = frames.map(fr => {
      const { x, y, w, h } = fr.frame
      const txt = new Texture(baseTxt, new Rectangle(x, y, w, h))
      return txt
    })
    return textures
  }


  setShuttleContainer = (container) => (this.container = container);

  startLaunchAnimation = () => {
  };

  removeShuttle = () => {
  };
}
